import React from "react";
import AppButton from "../AppButton";
import "./style.css";

type AppPaginationProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  buttonStyle?: React.CSSProperties;
  activeStyle?: React.CSSProperties;
  buttonClassName?: string;
  activeClassName?: string;
};

const AppPagination: React.FC<AppPaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  buttonStyle,
  activeStyle,
  buttonClassName,
  activeClassName,
}) => {
  const visiblePages = getVisiblePages(currentPage, totalPages);

  function getVisiblePages(current: number, total: number): number[] {
    const MAX_VISIBLE_PAGES = 10;
    if (total <= MAX_VISIBLE_PAGES) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }

    const pages: number[] = [];
    const firstPage = 1;
    const lastPage = total;
    let start = Math.max(current - 1, 2);
    let end = Math.min(current + 1, total - 1);

    // Adjust window if near the start
    if (current <= 3) {
      start = 2;
      end = 5;
    }
    // Adjust window if near the end
    if (current >= total - 2) {
      start = total - 5;
      end = total - 1;
    }

    pages.push(firstPage);
    if (start > 2) {
      pages.push(-1); // Ellipsis
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (end < total - 1) {
      pages.push(-2); // Ellipsis
    }
    pages.push(lastPage);
    return pages;
  }

  const handleClick = (page: number) => {
    if (page !== currentPage && page > 0 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="app-pagination">
      <AppButton
        label="Anterior"
        onClick={() => handleClick(currentPage - 1)}
        disabled={currentPage === 1}
        className={`app-pagination-button back ${buttonClassName}`}
        style={buttonStyle}
      />

      {visiblePages.map((page, index) =>
        page > 0 ? (
          <AppButton
            label={String(page)}
            key={index}
            onClick={() => handleClick(page)}
            className={`app-pagination-button page ${currentPage === page ? `active ${activeClassName}` : `${buttonClassName}`}`}
            style={{ ...(currentPage === page ? activeStyle : { ...buttonStyle }) }}
          />
        ) : (
          <span key={index} className="app-pagination-dots">
            ...
          </span>
        )
      )}

      <AppButton
        label="Próximo"
        onClick={() => handleClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`app-pagination-button next ${buttonClassName}`}
        style={buttonStyle}
      />
    </div>
  );
};

export default AppPagination;
